module.exports = __webpack_public_path__ + "static/media/12_strawberry.bfa476e7.JPG";